import React from "react";
// import PopupApcode, { OnGetAPcode } from './../PopUp/PopUpApcode';
import {
  genURL,
  gengetURLTEST,
  genpostURL,
  genpostURLTEST,
} from "./../_getjson";
import PopUpOther from "./../PopUp/PopUpOther";
import { parseJwt } from "../parseJWT";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { DropdownButton, MenuItem, Row, Col, Panel } from "react-bootstrap";
import PopUpItem from "./../PopUp/PopUpItem";
import PopUpwarehouse from "./../PopUp/PopUpwarehouse";
import PopUpSearchDoc from "./../PopUp/PopUpSearchDoc";
import { ReDate } from "./../_source/Datefn";
import { checkunit } from "../_source/checkUnit";
import axios from "axios";
import Backdrop from "./../Components/CustomBackdrop/Barckdrop";
import Snackbar from "./../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import CheckDepartmentname from "../CustomFunction/Department/Checkname";
import CheckBranchname from "../CustomFunction/Branch/Checkname";
import CheckUser from "../CustomFunction/Csuser/GetUser";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers";
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialog from "./../PopUp/FullScreendialogs/FullScreen";
import SelectDatas from "./../PopUp/SelectData";
import CustomInputtext from "./../Components/CustomInput/Inputtext";
import Rechecked from "./Components/Rechecked";
import { Grid } from "@mui/material";
import InputTemplate from "../Components/CustomInput/InputTemplate/inputtemplate";
import Repostview from "../Components/Reportview/Repostview";
const rowTable = 300;
const listmenu = [["...", "..."]];

export default class index extends React.Component {
  constructor(props) {
    super(props);
    this.Groupdata_code = React.createRef();
    this.Groupdata = React.createRef();
    this.DeliNumber = React.createRef();
    this.REMARK = React.createRef();
    this.SaleMan_code = React.createRef();
    this.SaleMan = React.createRef();
    this.Department_code = React.createRef();
    this.Department = React.createRef();
    this.Branch_code = React.createRef();
    this.Branch = React.createRef();
    this.AgentCode = React.createRef();
    this.MTSerialNo = React.createRef();
    this.MTLicenseNo = React.createRef();
    this.MTColor = React.createRef();
    this.Site_code = React.createRef();

    this.state = {
      siteCodeUser: "",
      chkcountcodeintable: 0,
      DOCGROUP_code: "",
      DOCGROUP_txt: "",
      Department_code: "",
      Department_txt: "",
      Branch_code: "",
      Branch: "",
      SiteCode_txt: "",
      autoClose: 3600,
      messagealert: "",
      OrderDate: "",
      openBackdrop: false,
      checkenableInput: false,
      PROJECT: "",
      defaultvaluewarehouse: "",
      defaultwarehouse: "",
      defaultlocetion: "",
    };
  }
  componentDidMount() {
    this.setRow(rowTable);
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
    /* if (localStorage.getItem('UsernameTH')) { */
    this.onAddValue("SaleMan", SITECODESTR.User.CODE);
    this.onAddValue("Branch", SITECODESTR.User.SITECODE);
    this.onAddValue("Groupdata", "PR"); /// มี PR รหัสเดียว เลย Fixไว้เพื่อความเท่
    this.SaleMan.current.value = localStorage.getItem("UsernameTH");
    //เช็คเปิดปิด textbox
    this.setState({
      checkenableInput: JSON.parse(localStorage.getItem("checkoftxt")),
    });

    let mid = new URLSearchParams(location.search).get("mid");
    this.loadFromindb(mid);
  }

  loadFromindb = async (mid) => {
    //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ
    //console.log("res.data", mid)
    let url = `reportmanage/reportform/${mid}?`;
    //console.log("res.data", genURL(url))
    let res = await axios.get(genURL(url));
    if (res.data.length > 0) {
      await this.setState({ reporturl: res.data[0].pathname });
      await this.setState({ formPrintdata: res.data });
    }
  };
  ResetThisPage = (type) => {
    if (type === "NEW") {
      if (this.state.iconNoWash) {
        this.onAddValue("Groupdata", "PR");
      } else {
        this.componentDidMount();
      }
    } else if (type === "SAVE") {
      window.location.reload();
    }
  };
  _ResetThisPage = (e) => {
    window.location.reload();
  };
  escapeRegExp(str) {
    return str.replace(/,/g, " ");
  }
  _connectsaveData = () => {
    this.saveData();
  };
  saveData = async () => {
    const parameter = new URLSearchParams();

    let items = [];
    let itemarr = [];
    for (
      var i = 0;
      i < this.state.products.length && this.state.products[i].Productcode;
      i++
    ) {
      if (this.state.products[i].Productcode !== "") {
        let wantdate = this.state.products[i].datetime;

        items[i] = {
          Productcode: this.state.products[i].Productcode, //0
          Productname: this.state.products[i].Productname, //1
          Defaultwarehouse: this.state.products[i].Defaultwarehouse, //2
          Defaultlocetion: this.state.products[i].Defaultlocetion, //3
          Unitcode: this.state.products[i].unitcode, //4
          Quantity: this.state.products[i].quantity, //5
          Wantdate: wantdate !== "" ? "'" + wantdate + "'" : "NULL", //6
          Remark: this.state.products[i].Remark, //7
          Productset: this.state.products[i].PRODUCTSET, //8
        };
        itemarr.push(items[i]);
      }
    }

    /* Success */
    parameter.append("listitem", JSON.stringify(itemarr));
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("DOCNO", this.DeliNumber.current.value);
    parameter.append("REMARK", this.REMARK.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("DEPARTMENT", this.state.Department_code);
    parameter.append("SITECODE", this.Branch_code.current.value);
    parameter.append("COMPUTERNAME", "");
    parameter.append("PROJECT", this.state.PROJECT);
    parameter.append("DocDate", this.state.OrderDate);
    /* Still left */
    /* parameter.append("model", this.state.model) */
    // let strDOCGROUP = ""
    // let strSITECODE = ""
    var Uststus = true;
    for (var pair of parameter.entries()) {
      console.log(pair);
      if (pair[0] === "ARCODE" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });
        return;
      } else if (pair[0] === "DOCGROUP" && pair[1] === "") {
        //  console.log("DOCGROUP", pair[0]);

        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกกลุ่มข้อมูล" });
        return;
      } else if (pair[0] === "DEPARTMENT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกแผนก" });
        return;
      } else if (pair[0] === "SITECODE" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกสาขา" });
        return;
      }
    }

    let n = this.Groupdata_code.current.value.startsWith(
      "PR" + this.Branch_code.current.value
    );
    //   console.log("nnnnnnnnnnnnnnnnnnnssss", n);
    if (n === false) {
      Uststus = false;
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กลุ่มข้อมูลและสาขาไม่สัมพันธ์กัน" });
      return;
    }

    for (
      var i1 = 0;
      i1 < this.state.products.length && this.state.products[i1].Productcode;
      i1++
    ) {
      if (
        this.state.products[i1].Defaultwarehouse !==
        this.Branch_code.current.value
      ) {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "สาขาและคลังสินค้าไม่สัมพันธ์กัน" });
        return;
      }
    }
    console.log(parameter.entries());
    if (Uststus === true) {
      this.setState({ openBackdrop: true });
      await axios
        .post(genpostURL("CSPR/Save?"), parameter)
        .then((res) => {
          // await axios.post(genpostURLTEST("/Save?"), parameter).then(res => {

          console.log(res.data);
          if (res.data.status === "success") {
            this.setState({ opensnackbar: true });
            this.setState({ color: "success" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกสำเร็จ" });
            setTimeout(() => {
              if (this.state.reporturl !== "") {
                this.setState({ openBackdrop: false });
                this._print(res.data.docno);
              } else {
                this.ReplacePage(window.location.pathname + location.search);
              }
            }, 30);
          } else {
            this.DeleteData(this.DeliNumber.current.value);
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกไม่สำเร็จ" });
            this.setState({ openBackdrop: false });
          }
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
          this.setState({ openBackdrop: false });
        });
    }
  };
  _print = (docno) => {
    try {
      if (formPrintdata.length > 1) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({
          messagealert:
            "กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length,
        });
        return;
      }
    } catch (error) {}

    if (this.state.reporturl !== "") {
      this.setState({
        openFullScreenDialog: true,
        typeFullScreenDialog: "Report",
        titleFullScreenDialog: "พิมพ์ใบบันทึกขอสั่งซื้อ",
        urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.formPrintdata[0].pathname}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docno}`,
      });
      return;
    } else {
      this.ResetThisPage("SAVE");
    }
  };
  DeleteData = (docno) => {
    console.log(docno);
  };
  ClickAll = (e) => {
    var Name = e.target.name;
    //console.log(Name)
    switch (Name) {
      case "Groupdata":
        this.setState({ Groupdata: this.state.DOCGROUP_code });
        this.Groupdata.current.value = this.state.DOCGROUP_code;
        break;
      case "Department":
        this.setState({ Department: this.state.Department_code });
        this.Department.current.value = this.state.Department_code;
        break;
      case "Branch":
        this.Branch.current.value = this.Branch_code.current.value;
        break;
      /* default: break; */
    }
  };

  onClickDocNo = async () => {
    if (!this.state.DOCGROUP_code) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "ไม่พบข้อมูล" });
    }
    if (this.state.DOCGROUP_code) {
      var url =
        "CSMAXDOC/MAXDOC?tablename=CSPR&provenance=&code=" +
        this.state.DOCGROUP_code.trim();
      console.log(genURL(url));
      await axios.get(genURL(url), { timeout: 3600 }).then((res) => {
        if (res.data.maxdoc.length > 0) {
          this.DeliNumber.current.value = res.data.maxdoc;
        } else {
          this.DeliNumber.current.value = "";
        }
      });
    } else {
      this.DeliNumber.current.value = "";
    }
  };
  Onblur = (e) => {
    switch (e.target.name) {
      case "Department":
        this.Department.current.value = this.state.Department_txt;
        break;
      case "Branch":
        this.Branch.current.value = this.state.SiteCode_txt;
        break;
      case "Groupdata":
        this.Groupdata.current.value = this.state.DOCGROUP_txt;
        break;
      case "ARCode":
        if (e.target.value === "") {
          this.ARCode.current.value = "";
          this.ARName.current.value = "";
        }
        break;
      default:
        break;
    }
  };
  /* Enter */
  _checkDocgroup = async (e) => {
    if (e.key === "Enter") {
      this.setState({ openBackdrop: true });
      var url = "CSDOCGROUP/Code?tablename=CSPR&code=" + e.target.value;
      console.log(genURL(url));
      await axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          if (res.data.length > 0) {
            this.setState({ DOCGROUP_txt: res.data[0].MYNAMETH });
            this.setState({ DOCGROUP_code: res.data[0].CODE });
            this.Groupdata_code.current.value = res.data[0].CODE;
            this.Groupdata.current.value = res.data[0].MYNAMETH;
            this.setState({ openBackdrop: false });
            this.onClickDocNo();
          } else {
            this.setState({ openBackdrop: false });
            this.setState({ DOCGROUP_txt: "" });
            this.setState({ DOCGROUP_code: "" });
            this.Groupdata_code.current.value = "";
            this.Groupdata.current.value = "";
            this.DeliNumber.current.value = "";
          }
        })
        .catch((error) => {
          this._chkload("Error" + error);
          this.setState({ openBackdrop: false });
        });
    }
  };
  _checkDepartmant = (e) => {
    if (e.key === "Enter") {
      this._checkDepartmantcalldb(e.target.value);
    }
  };
  _checkDepartmantcalldb = async (e) => {
    this.setState({ openBackdrop: true });
    var url =
      "CSDEPARTMENT/ByCode?code=" +
      e +
      "&user=" +
      localStorage.getItem("Username");
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        if (res.data.length > 0) {
          this.setState({ Department_txt: res.data[0].MYNAMETH });
          this.setState({ Department_code: res.data[0].CODE });
          this.Department.current.value = res.data[0].MYNAMETH;
          this.setState({ openBackdrop: false });
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูล" });
          this.setState({ Department_txt: "" });
          this.setState({ Department_code: "" });
          this.Department.current.value = "";
          this.setState({ openBackdrop: false });
        }
      })
      .catch((error) => {
        this._chkload("Error" + error);
        this.setState({ openBackdrop: false });
      });
  };
  // _handleBlur=(e)=>{
  //      if(e.target.value!=""){
  //        this._checkDepartmantcalldb(e.target.value)
  //      }
  // }

  ///    ค้างตรงนี้

  KeyDown_fn = async (e, source) => {
    console.log("e", e.key);
    if (e.key === "Enter") {
      this.onAddValue(source, e.target.value, "");
    }
  };

  SelectSetData = (data1, data2) => {
    switch (data1) {
      case "Calendar":
        console.log(data2);
        this.setState({ OrderDate: data2 });
        break;
      case "SaleType":
        this.SaleType.current.value = data2;
        break;
      case "PROJECT":
        this.setState({ PROJECT: data2 });
        console.log("PROJECT", data2);
        break;
      default:
        break;
    }
  };
  Get_PopUpOther = (data) => {
    this.CloseDialog(false);
    var data = data.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        this.setState({ DOCGROUP_code: data[0] });
        this.setState({ DOCGROUP_txt: data[1] });
        this.onAddValue("Groupdata", data[0]);
        break;
      case "Department":
        /* OnClick */
        this.setState({ Department_code: data[0] });
        /* OnBlur */
        this.setState({ Department_txt: data[1] });
        /* this.Department_code.current.value = data[0]; */
        this.Department.current.value = data[1];
        break;
      case "CreditCode":
        this.CreditCode_code.current.value = data[0];
        this.CreditCode.current.value = data[1];
        this.setState({ creditType: data[0] });
        ////console.log(data[0])
        var dateP = parseFloat(data[0].substring(1));
        break;
      case "Branch":
        /* OnClick */

        /* OnBlur */
        // this.setState({ SiteCode_txt: data[1] })
        /* this.Branch_code.current.value = data[0]; */
        // this.Branch.current.value = data[1];

        this.onAddValue("Branch", data[0]);

        break;
      case "EventType":
        this.EventType.current.value = data[1];
        this.setState({ EventType: data[0] });
        break;

      case "typeofcar":
        this.typeofcar.current.value = data[1];
        this.setState({ Typeofcar: data[0] });
        break;
      default:
        break;
    }
  };
  Get_warehouse = (data) => {
    this.CloseDialog(false);
    var DataValue = data.split("|");
    var Pr = this.state.products;
    var r = this.state.WHRow;
    Pr[r].Defaultwarehouse = DataValue[0];
    Pr[r].Defaultlocetion = DataValue[2];
    console.log(DataValue[2]);
    setTimeout(() => {
      this.setState({ products: Pr });
      this.checkStkwarehouse(this.state.WHRow);
    }, 100);
  };
  checkStkwarehouse = async (row) => {
    var col = this.state.products;
    var urll =
      "CSSTKWAREHOUSE/checkstockqty?productcode=" +
      col[row].Productcode +
      "&warehouse=" +
      this.state.productcodeinrow1 +
      "&location=" +
      col[row].Defaultlocetion;
    var chki = 0;
    console.log(genURL(urll));
    await axios
      .get(genURL(urll), { timeout: 3600 })
      .then((res) => {
        console.log(res);
        var chkloc = 0;
        for (var i = 0; i < res.data.length; i++) {
          chkloc = chkloc + 1;
          chki = chki + 1;
          col[row].MaxUnit = res.data[i].STOCKQTY;
          // col[row].Defaultlocetion = res.data[i].LOCATION;
        }
        setTimeout(() => {
          this.setState({ products: col });
        }, 100);
      })
      .then((_) => {
        setTimeout(() => {
          this.ReLoadData();
        }, 500);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  CalendarOnChange = (data, DateUp) => {
    var Backup = "";
    var today = new Date(data);
    if (DateUp) {
      today.setDate(today.getDate() + DateUp);
    }
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + (yyyy + 543);

    setTimeout(() => {
      Backup = this.state.MenuItem;
      this.setState({ MenuItem: "" });
    }, 0);
    setTimeout(() => {
      this.setState({ MenuItem: Backup });
    }, 10);
    return today;
  };

  onAddValue = async (type, value, Fix) => {
    if (value) {
      var Url = "";
      switch (type) {
        case "Groupdata":
          Url =
            "CSDOCGROUP/Code?tablename=CSPR&code=" +
            value +
            "&user=" +
            localStorage.getItem("Username") +
            "&top=30";
          console.log(genURL(Url));
          await axios
            .get(genURL(Url), { timeout: 3600 })
            .then(async (res) => {
              if (res.data.length === 1) {
                this[type].current.value = res.data[0].MYNAMETH;
                this.setState({ DOCGROUP_txt: res.data[0].MYNAMETH });
                this[type + "_code"].current.value = res.data[0].CODE;
                var CODE = res.data[0].CODE.trim();
                if (!Fix) {
                  var url1 = "CSMAXDOC/MAXDOC?tablename=CSPR&code=" + CODE;
                  console.log(genURL(url1));
                  await axios
                    .get(genURL(url1), { timeout: 3600 })
                    .then((res) => {
                      if (res.data) {
                        this.DeliNumber.current.value = res.data["maxdoc"];
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              } else {
                this[type].current.value = "";
                this[type + "_code"].current.value = "";
                this.DeliNumber.current.value = "";
              }
            })
            .catch((error) => {
              this._chkload("Error" + error);
            });
          break;
        case "SaleMan":
          await CheckUser(value)
            .then((result) => {
              if (result !== undefined) {
                this.SaleMan_code.current.value = value;
                this.SaleMan.current.value = result;
              } else {
                // AlertPopup("Warning", "ไม่พบข้อมูล!");
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล พนักงาน" });

                this.SaleMan_code.current.value = "";
                this.SaleMan.current.value = "";
              }
            })
            .catch((err) => {
              this.SaleMan_code.current.value = "";
              this.SaleMan.current.value = "";
            });
          break;
        case "Department":
          await CheckDepartmentname(value)
            .then((result) => {
              //console.log("result",result);
              this.Department_code.current.value = value;
              this.Department.current.value = result;
              this.setState({ Department_txt: result });
              this.setState({ Department_code: value });
              this.setState({ Department: result });
            })
            .catch((err) => {
              this.Department_code.current.value = "";
              this.Department.current.value = "";
            });
          break;
        case "Branch":
          await CheckBranchname(value)
            .then((result) => {
              if (result !== undefined) {
                this.Branch_code.current.value = value;
                this.Branch.current.value = result;
                this.setState({ SiteCode_txt: result });
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล สาขา" });
                this.Branch_code.current.value = "";
                this.Branch.current.value = "";
                this.setState({ SiteCode_txt: "" });
              }
            })
            .catch((err) => {
              // this.Branch_code.current.value = ""
              // this.Branch.current.value = ""
              // this.setState({ SiteCode_txt: "" });
              console.log(err);
            });

          break;
        default:
          break;
      }
    }
  };
  /*---------------------------------------------vvvvvvvvvvvvvvv---popup product ---vvvvvvvvvvvvvvv---------------------------------------------*/
  _cellButton(cell, row, enumObject, rowIndex) {
    var btn = this.state.products[rowIndex].btn1;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={() => this.Switch_PopUpItem("search_table")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  _chkload = (cell, row, enumObject, rowIndex) => {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  };
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ products: data });
  };
  rowClassNameFormat = (row, rowIdx) => {
    return "trClassName";
  };
  // คลิก Table
  onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.Productcode });
    this.setState({ WHRow: id });
    var Pr = this.state.products;
    var j = row.C0 - 1;
    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });
    // จำนวนเต็มเวลาคลิก
    let quantity = row.quantity;
    if (col === 9 && quantity !== "" && quantity !== undefined) {
      row.quantity = parseFloat(quantity).toFixed(0);
    }
    for (var i = 0; i < Pr.length; i++) {
      Pr[i].btn1 = 0;
      Pr[i].btn_DeliDate = 0;
      Pr[i].btn_DeliDate1 = 0;
    }

    // หาจากล่างขึ้นบน
    for (var i = Pr.length - 1; i >= 0; i--) {
      //หา แถวที่ว่างบนสุดใน products Table
      if (!Pr[i].Productcode) {
        j = i;
      }
    }

    // BTN ค้นหาได้เฉพาะในแถว
    if (
      (col === 1 && j === id) ||
      (col === 1 && Pr[id].Productcode !== undefined)
    ) {
      this.setState({ col1: true });
      Pr[id].btn1 = 1;
    } else if (
      col === 4 &&
      typeof row.Productcode !== "undefined" &&
      row.Productcode !== ""
    ) {
      this.setState({ productcodeinrow: row.Productcode });
      this.setState({ productcodeinrow1: row.Defaultwarehouse });
      // if (row.stocktype !== 1) {
      Pr[id].btn_DeliDate = 1;
      // }
    } else if (
      col === 6 &&
      typeof row.Productcode !== "undefined" &&
      row.Productcode !== ""
    ) {
      this.setState({ productcodeinrow: row.Productcode });
      this.setState({ productcodeinrow1: row.Defaultwarehouse });
      // if (row.stocktype !== 1) {
      Pr[id].btn_DeliDate1 = 1;
      // }
    }

    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.Productcode !== "undefined" && row.Productcode !== "") {
      this.setState({ col: true });
      // BTN วันที่
      Pr[id].BTN_DelDate = 1;
    }

    setTimeout(() => {
      this.setState({ products: Pr });
    }, 100);
  };

  onAfterSaveCell = (row, cellName, cellValue) => {
    console.log(row);
    var cellValue1 = this.state.cellValue;
    var col = this.state.products;
    // ทศนิยม 2 ตำแหน่ง ปริมาณ ราคา ลด
    let quantity = row.quantity;
    if (cellName === "quantity" && quantity !== "") {
      row.quantity = parseFloat(quantity).toFixed(2);
    }
    //end
    if (
      cellName === "Productcode" &&
      cellValue !== "" &&
      cellValue1 !== cellValue
    ) {
      col[row.C0 - 1] = [];
      col[row.C0 - 1].C0 = row.C0;
      col[row.C0 - 1].btn1 = row.btn1;
      this.setState({ products: col });
      this.AddDataTable(cellValue, row.C0 - 1, "", "");
    } else if (cellName === "Productcode" && cellValue === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
    } else {
      this.ReLoadData();
    }
  };
  Get_PopUpItem = (code, data, stockCode) => {
    this.CloseDialog(false);
    this.AddDataTable(code, this.state.TBLastClick - 1, data, stockCode);
  };
  AddDataTable = async (ItemCode, row) => {
    var col = this.state.products;
    /* รหัสสินค้าซ้ำกันเพิ่มจำนวน ปริมาณ */
    for (var i = 0; i < col.length; i++) {
      if (col[i].Productcode === ItemCode) {
        col[i].quantity = parseFloat(Number(col[i].quantity) + 1).toFixed(2);
        this.setState({ products: col });
        return;
      }
    }
    var url =
      "CSPRODUCT/GetAllProductcode?code=" +
      ItemCode +
      "&user=" +
      localStorage.getItem("Username");
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then(async (res) => {
        var j = 0;
        if (row > -1) {
          j = row;
        } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
          j = this.state.TBLastClick - 1;
        } else {
          for (var i = this.state.products.length - 1; i >= 0; i--) {
            // หาจากล่างขึ้นบน
            if (!this.state.products[i].Productcode) {
              j = i;
            }
          }
        }
        if (res.data.length > 0) {
          for (let index = 0; index < res.data.length; index++) {
            var STOCKTYPE = 0;
            var url1 =
              "CSPRODUCT/Code?productset=0&stocktype=&code=" +
              res.data[index].PRODUCTCODE;
            console.log(genURL(url1));
            await axios
              .get(genURL(url1), { timeout: 3600 })
              .then(async (result) => {
                console.log(result.data);
                if (result.data.length > 0) {
                  STOCKTYPE = await result.data[0].STOCKTYPE;
                }
              });
            var unit = "";
            await checkunit(res.data[index].UNITCODE).then((result) => {
              unit = result;
              console.log(unit);
            });
            col[j] = {
              C0: j + 1,
              Productcode: res.data[index].PRODUCTCODE,
              btn1: col[0].btn1,
              Productname: res.data[index].PRODUCTNAME,
              Defaultwarehouse: this.state.defaultwarehouse,
              Defaultlocetion: this.state.defaultlocetion,
              unitname: unit, //ต้องเช็คเพราะตัวสินค้ากลุ่มไม่มีใน  CSPRODUCT/Code?productset
              unitcode: res.data[index].UNITCODE,
              quantity: (1).toFixed(2),
              datetime: "",
              Remark: "",
              PRODUCTSET:
                res.data[index].PARENTCODE == res.data[0].PRODUCTCODE
                  ? "2"
                  : String(res.data[index].PRODUCTSET), //ถ้าเป็นลูกของสินค้ากลุ่ม == 2
              stocktype: res.data[index].STOCKTYPE, //กำหนดให้ค้นหาคลังได้หรือไม่ได้
            };
            j++;
            this.setState({ products: col });
            this.ReLoadData();
          }
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูลสินค้าในคลังสาขาของคุณ" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // setTimeout(() => {
    //     document.getElementById("TableLoadItem").innerHTML = "";
    //     console.log(document.getElementById("TableLoadItem").innerHTML);
    // }, 300)
  };
  //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
  ReLoadData = () => {
    var col = this.state.products;
    var NewCol = [];
    var j = 0;
    var Ch = 0;
    for (var i = 0; i < col.length; i++) {
      if (col[i].Productcode) {
        if (col[i].Productcode[0] + "" + col[i].Productcode[1] === "11") {
          Ch++;
        }
        NewCol[j] = col[i];
        NewCol[j].C0 = j + 1;
        NewCol[j].BTN_DelDate = 1;
        NewCol[j].BTN_C3 = 1;
        NewCol[j].BTN_C4 = 1;
        NewCol[j].BTN_C5 = 1;
        j++;
      }
    }
    for (var i = j; i < col.length; i++) {
      NewCol[j] = { C0: j + 1 };
      j++;
    }
    this.setState({ products: NewCol });
  };
  /*----------------------------------------------------------Switch----------------------------------------------------------*/
  Switch_PopUpItem = (e) => {
    // this.setState({ SwitchPopUpItem: !this.state.SwitchPopUpItem })
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาสินค้า-product" });
  };
  Switch_OtherPopup = (e) => {
    //ชื่อ
    this.setState({ OtPopupType: e });
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    if (e === "Groupdata") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" });
    }
    if (e === "Department") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" });
    }
    if (e === "Branch") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" });
    }
  };
  /*----------------------------------------------------------Switch----------------------------------------------------------*/
  /*----------------------------------------------------------พิเศษ----------------------------------------------------------*/
  SwitchValue = (ref, type) => {
    if (type === "EnterEvent") {
      var M_data = this[ref].current.value;
      var D_data = this[ref + "_code"].current.value;
      this[ref].current.value = D_data;
      this[ref + "_code"].current.value = M_data;
    } else {
      if ((type === "IN" && this.state.LastRef !== ref) || type === "OUT") {
        var M_data = this[ref].current.value;
        var D_data = this[ref + "_code"].current.value;
        this[ref].current.value = D_data;
        this[ref + "_code"].current.value = M_data;
        this.setState({ LastRef: ref });
      }
      if (type === "OUT" && this.state.LastRef === ref) {
        this.onAddValue(ref, M_data);
        this.setState({ LastRef: "" });
      }
    }
  };
  onChangeData = (e) => {
    var Ref = this.state.LastRef;
    if (e.key === "Enter") {
      this.onAddValue(Ref, e.target.value).then((res) => {
        this.SwitchValue(Ref, "EnterEvent");
      });
    }
  };
  _reCHK = async (RowData) => {
    this.CloseDialog(false);
    console.log("RowData", RowData);
    // this.setState({ DATE1: DATE11, DATE2: DATE22 })
    this.setState({ _saveStatus: true });
    this.setRow(rowTable);
    var url = "CSPR/GetCSPRmain?code=" + RowData[0].docNo;
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        if (res.data.length > 0) {
          this.setState({
            defaultvaluewarehouse:
              "รหัสคลัง: " +
              res.data[0].SITECODE +
              "  รหัสที่เก็บ: " +
              res.data[0].SITECODE +
              "001",
          });
          if (res.data[0].DOCGROUP !== "") {
            this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y").then(
              (No) => {
                this.DeliNumber.current.value = res.data[0].DOCNO;
                this.setState({ DOCGROUP_code: res.data[0].DOCGROUP });
              }
            );
          }
          this.REMARK.current.value = res.data[0].REMARK;
          this.onAddValue("Department", res.data[0].DEPARTMENT);
          this.setState({ Department_code: res.data[0].DEPARTMENT });
          this.onAddValue("Branch", res.data[0].SITECODE);
          console.log(ReDate(res.data[0].DOCDATE));
          this.setState({ OrderDate: ReDate(res.data[0].DOCDATE) });
          this.onAddValue("SaleMan", res.data[0].PRCREATOR);
        }
      })
      .catch((error) => {
        this._chkload("Error" + error);
      });
    var url1 = "CSPR/GetCSPRsub?code=" + RowData[0].docNo;
    console.log(genURL(url1));
    await axios
      .get(genURL(url1))
      .then(async (res) => {
        if (res.data.length > 0) {
          var data = this.state.products;
          for (var i = 0; i < res.data.length; i++) {
            var unit = "";
            var date = res.data[0].DOCDATE.split("T");
            console.log(date);
            await checkunit(res.data[i].UNITCODE).then((data) => {
              unit = data;
            });
            data[i].Productcode = res.data[i].PRODUCTCODE;
            data[i].Productname = res.data[i].PRODUCTNAME;
            data[i].Defaultwarehouse = res.data[i].WAREHOUSE;
            data[i].Defaultlocetion = res.data[i].LOCATION;
            data[i].unitname = unit;
            data[i].unitcode = res.data[i].UNITCODE;
            data[i].quantity = res.data[i].QUANTITY;
            data[i].datetime = res.data[i].DOCDATE ? date[0] : "";
            data[i].Remark = res.data[i].REMARK;
            data[i].PRODUCTSET = res.data[i].PRODUCTSET;
            if (i === res.data.length - 1) {
              await this.setState({ products: data });
            }
          }
        }
      })
      .catch((error) => {
        this._chkload("Error" + error);
      });
  };

  //**  ค้นหายี่ห้อ รุ่น* */*********************************************************** */

  _handleSearch = async () => {
    this.setState({ isLoading: true });
    var _url = "";
    var _code = "";
    var _name = "";
    switch (this.state.chkfocus) {
      case "dimension":
        _url = "CSDIMENSION1/getdata?";
        _code = "CODE";
        _name = "MYNAMETH";
        break;

      case "brandname":
        _url = "CSPDSUBGROUP2/GetAll?";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
      case "model":
        _url = "CSPDSUBGROUP3/GetAll?top=500";
        _code = "CODE";
        _name = "MYNAMETH";
        break;

      case "color":
        _url = "/CSPDSUBGROUP4/all?";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
    }

    console.log(genURL(_url));
    await axios.get(genURL(_url), { timeout: 3600 }).then((res) => {
      //console.log(res)
      if (res !== "error") {
        var element = [];
        for (let index = 0; index < res.data.length; index++) {
          element.push(res.data[index][_code] + " | " + res.data[index][_name]);
        }
        //console.log(element)
        this.setState({
          isLoading: false,
          options: element,
        });
      }
      setTimeout(() => {
        //console.log(this.state.options)
      }, 300);
    });
  };

  _blurinput = () => {
    //  //console.log("xxxx" + this.input.current.value)
    var _txtselect = "";
    var _code = "";
    switch (this.state.chkfocus) {
      case "dimension":
        _txtselect = "" + this.state.selecteddimension;
        _code = _txtselect.split("|");
        this.setState({ dimension: _code[0].trim() });
        // setTimeout(() => {
        //      //console.log("_nametxt" + this.state.dimension)
        // }, 100)
        break;

      case "brandname":
        _txtselect = "" + this.state.selectedbrandname;
        _code = _txtselect.split("|");
        this.setState({ brandname: _code[0].trim() });
        // setTimeout(() => {
        //      //console.log("_nametxt" + this.state.brandname)
        // }, 100)
        break;
      case "model":
        _txtselect = "" + this.state.selectedmodel;
        _code = _txtselect.split("|");
        this.setState({ model: _code[0].trim() });
        // setTimeout(() => {
        //      //console.log("_nametxt" + this.state.dimension)
        // }, 100)
        break;

      case "color":
        _txtselect = "" + this.state.selectedcolor;
        _code = _txtselect.split("|");
        this.setState({ color: _code[0].trim() });
        break;
    }
    // setTimeout(() => {
    //     //console.log("dimension" + this.state.dimension)
    // }, 100)
  };
  //*** */**************************************************************************** */
  _cellButton_btn_DeliDate = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].btn_DeliDate;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  _cellButton_btn_DeliDate1 = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].btn_DeliDate1;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  Switch_PopUpwarehouse = (type) => {
    switch (type) {
      case "setwarehousetable":
        if (this.state.productcodeinrow !== "") {
          // this.setState({
          //     SwitchPopUpwarehouse: !this.state.SwitchPopUpwarehouse
          // })
          this.setState({ PopUpWHType: type });
          //ชื่อ
          this.setState({ typeFullScreenDialog: type });
          //open
          this.setState({ openFullScreenDialog: true });
          //title
          this.setState({ titleFullScreenDialog: "เลือกคลังและตำแหน่งเก็บ" });
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบรหัสสินค้าในแถวที่ท่านเลือก" });
          return;
        }
        break;
    }
  };
  onChange = (e) => {
    switch (e.target.name) {
      case "Groupdata":
        if (e.target.value === "") {
          this.Groupdata.current.value = "";
          this.Groupdata_code.current.value = "";
          this.DeliNumber.current.value = "";
          this.setState({ DOCGROUP_code: "" });
          this.setState({ DOCGROUP_txt: "" });
        }
        break;
      case "Department":
        if (e.target.value === "") {
          this.setState({ Department_txt: "" });
          this.state.Department_txt = "";
        }
        break;
      case "Branch":
        if (e.target.value === "") {
          this.setState({ SiteCode_txt: "" });
          this.Branch_code.current.value = "";
          this.Branch.current.value = "";
        }
        break;
      default:
        break;
    }
  };
  onClickTopbar = (e) => {
    console.log(e);
    switch (e) {
      case "save":
        this._connectsaveData();
        break;
      case "new":
        this._ResetThisPage();
        break;
      case "print":
        console.log("print");
        break;
      case "search":
        //ชื่อ
        this.setState({ typeFullScreenDialog: e });
        //open
        this.setState({ openFullScreenDialog: true });
        //title
        this.setState({ titleFullScreenDialog: "ใบขอสั่งซื้อสินค้า" });
        break;
      default:
        break;
    }
  };
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
    if (this.state.typeFullScreenDialog === "Report") {
      this.ResetThisPage("SAVE");
    }
  };
  propsvalue = (data) => {
    if (data.source === "CSWAREHOUSEALL") {
      this.setState({ defaultwarehouse: data.warehouse });
      this.setState({ defaultlocetion: data.location });
    }
  };
  render() {
    const type = this.state.typeFullScreenDialog;
    return (
      <div className="PSApp" onChange={this.onChange}>
        <Backdrop open={this.state.openBackdrop} />

        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.CloseDialog(e)}
        >
          {type === "search" ? (
            <Rechecked Dataselect={(e) => this._reCHK(e)} />
          ) : null}
          {type === "Groupdata" ||
          type === "Department" ||
          type === "Branch" ? (
            <PopUpOther
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this.Get_PopUpOther}
              from="CSPR"
              userSite={""}
            />
          ) : null}
          {type === "search_table" ? (
            <PopUpItem
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUpItem={this.Get_PopUpItem}
              userSite={this.state.siteCodeUser}
              from="CSPR"
            />
          ) : null}
          {type === "setwarehousetable" ? (
            <PopUpwarehouse
              closePopup={(e) => this.CloseDialog(e)}
              type="setdefaultwarehouse"
              Get_PopUpOther={this.Get_warehouse}
              productcodeinrow={this.state.productcodeinrow}
              productcodeinrow1={this.state.productcodeinrow1}
              from="CSPR"
            />
          ) : null}
          {type === "Report" ? <Repostview url={this.state.urlsend} /> : null}
        </FullScreenDialog>
        <Topbar
          listmenu={listmenu}
          title="บันทึกใบขอสั่งซื้อสินค้า"
          onClick={(e) => this.onClickTopbar(e)}
        />
        <div className="PSAppfrom">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <MaterialUIPickers
                title="วันที่ขอสั่งซื้อ"
                DateValue={(e) => this.SelectSetData("Calendar", e)}
                defaultdate={this.state.OrderDate}
                open={this.state.checkenableInput["DOCDATE"]}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <InputTemplate
                title={"กลุ่มเอกสาร"}
                children={
                  <>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.Groupdata_code}
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="Groupdata"
                      ref={this.Groupdata}
                      tabIndex={1}
                      onClick={this.ClickAll}
                      onKeyDown={this._checkDocgroup}
                      onBlur={this.Onblur}
                    />
                    <span
                      id="iconGroupdata"
                      className="input-group-addon icon"
                      onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}
                    >
                      <i>
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </>
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <InputTemplate
                title={"เลขที่ใบขอสั่งซื้อ"}
                children={
                  <>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.DeliNumber}
                      readOnly={this.state.checkenableInput["TaxNo"] ? 0 : 1}
                    />
                  </>
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <InputTemplate
                title={"หมายเหตุ"}
                children={
                  <>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.REMARK}
                      tabIndex={2}
                    />
                  </>
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <InputTemplate
                title={"พนักงาน"}
                children={
                  <>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.SaleMan_code}
                    />
                    <input
                      type="text"
                      className="form-control"
                      ref={this.SaleMan}
                      disabled
                    />
                  </>
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <CustomInputtext
                title="คลังเริ่มต้น"
                value={this.state.defaultvaluewarehouse}
                disabledvalue={true}
                of_title={false}
                of_btn={false}
                source={"CSWAREHOUSEALL"}
                propsvalue={this.propsvalue}
              />
            </Grid>
          </Grid>
          <div className="container-fluid" style={{ marginTop: "15px" }}>
            <BootstrapTable
              data={this.state.products}
              trClassName="trClassName"
              tableHeaderClass="trClassName"
              options={{
                noDataText: "...",
                onRowClick: this.onRowClick,
              }}
              cellEdit={{
                mode: "click",
                blurToSave: true,
                afterSaveCell: this.onAfterSaveCell,
              }}
              /* keyBoardNav={{ enterToEdit: true }} */
              height="400"
            >
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="C0"
                isKey
                width="30"
                dataAlign="center"
                dataFormat={this._chkload.bind(this)}
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                headerAlign="center"
                width="120"
                className="colbuttomhidden"
              >
                รหัสสินค้า
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="Productcode"
                editable={this.state.col1}
                dataAlign="left"
                width="90"
              >
                {" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="Btn1"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._cellButton.bind(this)}
                columnClassName="columnClassNameFormat1"
              >
                <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="Productname"
                editable={false}
                dataAlign="center"
                width="140"
              >
                {" "}
                ชื่อสินค้า{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                dataAlign="center"
                width="120"
                className="colbuttomhidden"
              >
                {" "}
                คลัง{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="Defaultwarehouse"
                editable={this.state.col}
                dataAlign="center"
                width="90"
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="BTN_C3"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._cellButton_btn_DeliDate.bind(this)}
                columnClassName="columnClassNameFormat1"
              >
                {" "}
                <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                dataAlign="center"
                width="120"
                className="colbuttomhidden"
              >
                {" "}
                ตำแหน่งเก็บ{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="Defaultlocetion"
                editable={this.state.col}
                dataAlign="center"
                width="90"
              >
                {" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="BTN_C4"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._cellButton_btn_DeliDate1.bind(this)}
                columnClassName="columnClassNameFormat1"
              >
                {" "}
                <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="unitname"
                editable={false}
                dataAlign="center"
                width="80"
              >
                {" "}
                หน่วย{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="unitcode"
                dataAlign="center"
                hidden
              >
                unitcode
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="quantity"
                editable={this.state.col}
                dataAlign="center"
                width="80"
              >
                {" "}
                ปริมาณ{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="datetime"
                width="180"
                editable={{ type: "date" }}
                dataAlign="center"
              >
                วันที่ต้องการ
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="Remark"
                rowSpan="2"
                editable={this.state.col}
                dataAlign="center"
                width="150"
              >
                {" "}
                หมายเหตุ{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="PRODUCTSET"
                width="90"
                editable={false}
                hidden
              >
                PRODUCTSET
              </TableHeaderColumn>
            </BootstrapTable>
          </div>

          <div className="PSAppfrom">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <InputTemplate
                  title={"แผนก"}
                  children={
                    <>
                      <input
                        type="text"
                        className="form-control hidden"
                        ref={this.Department_code}
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="Department"
                        ref={this.Department}
                        tabIndex={3}
                        onClick={this.ClickAll}
                        onKeyDown={this._checkDepartmant}
                        onBlur={this.Onblur}
                      />
                      <span
                        id="iconDepartment"
                        className="input-group-addon icon"
                        onClick={this.Switch_OtherPopup.bind(
                          null,
                          "Department"
                        )}
                      >
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </span>
                    </>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <InputTemplate
                  title={"สาขา"}
                  children={
                    <>
                      <input
                        type="text"
                        className="form-control hidden"
                        ref={this.Branch_code}
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="Branch"
                        ref={this.Branch}
                        tabIndex={4}
                        onClick={this.ClickAll}
                        onKeyDown={(e) => {
                          this.KeyDown_fn(e, "Branch");
                        }}
                        onBlur={this.Onblur}
                      />
                      <span
                        id="iconBranch"
                        className="input-group-addon icon"
                        onClick={this.Switch_OtherPopup.bind(null, "Branch")}
                      >
                        <i>
                          {" "}
                          <ArrowDropDownRoundedIcon fontSize="small" />
                        </i>
                      </span>
                    </>
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={4}
                xl={4}
                sx={{ paddingTop: "5px" }}
              >
                <SelectDatas
                  origin="PROJECT" // โครงการ
                  valueSelect={(e) => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                  title="โครงการ"
                  defaultselect={this.state.PROJECT} // ค่าเริ่มต้นของ โครงการ
                />
              </Grid>
            </Grid>

            <Snackbar
              place="br"
              color={this.state.color}
              icon={this.state.icon}
              autoClose={this.state.autoClose}
              message={this.state.messagealert}
              open={this.state.opensnackbar}
              closeNotification={() => {
                this.setState({ opensnackbar: false });
              }}
              close
            />
          </div>
        </div>
      </div>
    );
  }
}
